// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/hotel_discovery_info.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_feature_hotel_price_range } from "./price_range_pb";

/**
 * Describes the file proto/model/feature/hotel/hotel_discovery_info.proto.
 */
export const file_proto_model_feature_hotel_hotel_discovery_info = /*@__PURE__*/
  fileDesc("CjRwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL2hvdGVsX2Rpc2NvdmVyeV9pbmZvLnByb3RvEgZjYXJtZW4ijgEKEkhvdGVsRGlzY292ZXJ5SW5mbxInCgtwcmljZV9yYW5nZRgBIAEoCzISLmNhcm1lbi5QcmljZVJhbmdlEhoKEnBvcHVsYXJfcm9vbV90eXBlcxgCIAMoCRIbChNhdmFpbGFiaWxpdHlfc3RhdHVzGAMgASgJEhYKDmtleV9oaWdobGlnaHRzGAQgAygJQjZaNGdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvaG90ZWxiBnByb3RvMw", [file_proto_model_feature_hotel_price_range]);

/**
 * Describes the message carmen.HotelDiscoveryInfo.
 * Use `create(HotelDiscoveryInfoSchema)` to create a new message.
 */
export const HotelDiscoveryInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_hotel_discovery_info, 0);

